import styled, { css } from 'styled-components';

const StyledContainer = styled.div<{
	$align?: 'left' | 'right';
}>`
	position: relative;
	display: flex;
	gap: 20px;
	user-select: none;
	${({ $align }) =>
		$align === 'right' &&
		css`
			> div {
				flex-direction: row-reverse;
			}
		`}
`;

const StyledButton = styled.div<{
	$dark?: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 20px;
	height: 20px;
	border-radius: 6px;
	background-color: #fff;
	transition: background-color 0.25s ease;
`;

const StyledKeyLabel = styled.div`
	position: relative;
	padding: 0 5px;
	font-family: 'GT Walsheim Pro';
	font-weight: bold;
	font-size: 12px;
	color: #000;
	transition: color 0.25s ease;
`;

const StyledKeyIcon = styled.div<{
	$src: string;
}>`
	width: 20px;
	height: 20px;
	mask-image: url(${(props) => props.$src});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 10px 10px;
	-webkit-mask-image: url(${(props) => props.$src});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 10px 10px;
	background-color: #000;
	transition: background-color 0.25s ease;
`;

const StyledLabel = styled.div`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	color: #fff;
	line-height: 18px;
	transition: color 0.25s ease;
`;

const StyledButtonContainer = styled.div<{
	$clickable: boolean;
	$fullScreenLayout?: boolean;
}>`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 10px;
	border-radius: 10px;
	background-color: ${(props) =>
		props.$fullScreenLayout
			? 'rgba(255, 255, 255, 0.1)'
			: 'rgba(0, 0, 0, 0.5)'};
	transition: background-color 0.25s ease;
	${({ $clickable }) =>
		!$clickable &&
		css`
			pointer-events: none !important;
		`}
	&:hover {
		cursor: pointer;
		background-color: #fff;
		${StyledButton} {
			background-color: #000;
			${StyledKeyLabel} {
				color: #fff;
			}
			${StyledKeyIcon} {
				background-color: #fff;
			}
		}
		${StyledLabel} {
			color: #000;
		}
	}
`;

export {
	StyledButton,
	StyledButtonContainer,
	StyledContainer,
	StyledKeyIcon,
	StyledKeyLabel,
	StyledLabel,
};
